export default {
  emits: ['remove'],
  props: {
    settings: {
      required: false,
      type: Object,
      default: () => {
        return {}
      }
    },
    editMode: {
      required: false,
      type: Boolean,
      default: false
    },
    id: {
      type: Number
    },
    layoutId: {
      type: Number
    },
    width: {
      type: Number,
      default: 0
    }
  }
}
